/* Golden Scoop Cookie Co. - theme JS */

/* ---------- Pickup selector ---------- */
// Recurring weekly slots (always available)
window.gsSlots = [
    {
        day: 5, label: 'Friday', time: '4:00 PM - 7:00 PM', startHour: 16, startMin: 0,
        location: 'The Local by Masrawy - 2275 Britannia Rd W, Unit 19 & 20, Mississauga, ON'
    },
    {
        day: 6, label: 'Saturday', time: '12:00 PM - 4:00 PM', startHour: 12, startMin: 0,
        location: 'The Local by Masrawy - 2275 Britannia Rd W, Unit 19 & 20, Mississauga, ON'
    },
    {
        day: 0, label: 'Sunday', time: '12:00 PM - 4:00 PM', startHour: 12, startMin: 0,
        location: 'The Local by Masrawy - 2275 Britannia Rd W, Unit 19 & 20, Mississauga, ON'
    }
];

// One-time pickup slots (only show on the specific date, YYYY-MM-DD)
window.gsOneTimeSlots = [];

function gsGetSlotForDate(d) {
    // Check one-time slots first (YYYY-MM-DD comparison)
    var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    var oneTime = window.gsOneTimeSlots.find(function(s) { return s.date === iso; });
    if (oneTime) return oneTime;
    // Fall through to recurring weekly slot
    return window.gsSlots.find(function(s) { return s.day === d.getDay(); });
}

function gsFindSlotByValue(value) {
    if (!value) return null;
    var all = (window.gsOneTimeSlots || []).concat(window.gsSlots || []);
    return all.find(function(s) { return value.indexOf(s.label + ',') === 0; });
}

(function populatePickupDates() {
    var select = document.getElementById('pickup-date');
    if (!select) return;
    var now = new Date();
    var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    // Cap at 3 recurring slots; one-time slots always show.
    // Same-day pickups are allowed - slots only disappear once the start time has passed.
    var MAX_RECURRING = 3;
    var recurringAdded = 0;
    for (var i = 0; i < 21 && recurringAdded < MAX_RECURRING; i++) {
        var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
        var slot = gsGetSlotForDate(d);
        if (!slot) continue;

        var isOneTime = !!slot.date;

        // Same-day cutoff: allow same-day orders until 4 PM. After 4 PM, today's slot rolls off.
        if (i === 0 && now.getHours() >= 16) continue;

        var locationShort = slot.location.split(' - ')[0];
        var dateStr = slot.label + ', ' + monthNames[d.getMonth()] + ' ' + d.getDate();
        var opt = document.createElement('option');
        opt.value = dateStr + ' (' + slot.time + ')';
        opt.textContent = dateStr + ' ' + slot.time + '  -  ' + locationShort;
        select.appendChild(opt);
        if (!isOneTime) recurringAdded++;
    }

    var saved = sessionStorage.getItem('gs_pickup');
    if (saved) {
        for (var j = 0; j < select.options.length; j++) {
            if (select.options[j].value === saved) {
                select.selectedIndex = j;
                window.selectedPickupDate = saved;
                updatePickupSelection();
                break;
            }
        }
    }
})();

function updatePickupSelection() {
    var select = document.getElementById('pickup-date');
    var wrapper = document.getElementById('pickup-selector');
    var grid = document.getElementById('products-grid');
    var notice = document.getElementById('products-locked-notice');
    if (!select) return;
    if (select.value) {
        wrapper.classList.add('confirmed');
        if (grid) grid.classList.add('unlocked');
        if (notice) notice.classList.add('hidden');
        window.selectedPickupDate = select.value;
        sessionStorage.setItem('gs_pickup', select.value);
        saveCartNote(buildCartNote());
    } else {
        wrapper.classList.remove('confirmed');
        if (grid) grid.classList.remove('unlocked');
        if (notice) notice.classList.remove('hidden');
        window.selectedPickupDate = null;
        saveCartNote(buildCartNote());
    }
}

function saveCartNote(note) {
    return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
    });
}

function buildCartNote() {
    var parts = [];
    if (window.selectedPickupDate) {
        parts.push('Pickup: ' + window.selectedPickupDate);
        var slot = gsFindSlotByValue(window.selectedPickupDate);
        if (slot) parts.push('Location: ' + slot.location);
    }
    return parts.join(' | ');
}

/* ---------- Cart Drawer ---------- */
function openCartDrawer(e) {
    if (e) e.preventDefault();
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
}

function closeCartDrawer() {
    document.getElementById('cart-drawer').classList.remove('open');
    document.getElementById('cart-overlay').classList.remove('open');
    document.body.style.overflow = '';
}

function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
}

function renderCart(cart) {
    if (!cart || typeof cart !== 'object') return;
    if (!Array.isArray(cart.items)) cart.items = [];
    if (typeof cart.item_count !== 'number') cart.item_count = cart.items.length;

    var itemsEl = document.getElementById('cart-items');
    var emptyEl = document.getElementById('cart-empty');
    var footerEl = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-subtotal');
    var countEl = document.getElementById('cart-count');
    var pickupBox = document.getElementById('cart-pickup-display');
    var pickupVal = document.getElementById('cart-pickup-value');

    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        if (itemsEl) itemsEl.innerHTML = '';
        if (footerEl) footerEl.style.display = 'none';
        if (pickupBox) pickupBox.style.display = 'none';
        return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.note && pickupBox && pickupVal) {
        pickupBox.style.display = 'block';
        pickupVal.textContent = cart.note.replace(/^Pickup:\s*/, '');
    } else if (pickupBox) {
        pickupBox.style.display = 'none';
    }

    if (itemsEl) {
        var html = '';
        cart.items.forEach(function(item, idx) {
            var line = idx + 1;
            html += '<div class="cart-item" data-line="' + line + '">' +
                (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') +
                '<div class="cart-item-info">' +
                    '<div class="cart-item-name">' + item.product_title + '</div>' +
                    '<div class="cart-item-price">' + formatMoney(item.final_price) + '</div>' +
                    '<div class="cart-item-qty">' +
                        '<button type="button" class="qty-btn" data-action="decrease" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
                        '<span>' + item.quantity + '</span>' +
                        '<button type="button" class="qty-btn" data-action="increase" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
                    '</div>' +
                '</div>' +
                '<button type="button" class="cart-item-remove qty-btn" data-action="remove" data-line="' + line + '" data-qty="0" aria-label="Remove">&times;</button>' +
            '</div>';
        });
        itemsEl.innerHTML = html;
    }
}

function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) { renderCart(cart); return cart; });
}

/* ---------- Event delegation for cart qty/remove buttons ---------- */
document.addEventListener('click', function(e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var qty = parseInt(btn.getAttribute('data-qty'), 10);
    if (isNaN(line) || isNaN(qty)) return;
    btn.disabled = true;
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
    }).then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
    }).then(function(cart) {
        renderCart(cart);
    }).catch(function(err) {
        console.error('Cart update failed:', err);
        btn.disabled = false;
    });
});

/* ---------- AJAX Add to Cart (fast path) ---------- */
document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('product-form')) return;

    if (!window.selectedPickupDate) {
        e.preventDefault();
        alert('Please select a pickup time above before adding to cart.');
        var sel = document.getElementById('pickup-selector');
        if (sel) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
    }

    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
    }

    var data = new FormData(form);
    // Open drawer immediately for perceived speed
    openCartDrawer();

    // Single request: add item + note in the sections response
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
    }).then(function(r) { return r.json(); })
      .then(function() {
          // One fetch to get the final cart state
          return fetch('/cart.js').then(function(r) { return r.json(); });
      }).then(function(cart) {
          renderCart(cart);
      }).catch(function(err) {
          console.error(err);
          alert('Something went wrong. Please try again.');
      }).finally(function() {
          if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to Cart';
          }
      });
});

/* ---------- Cart count on load ---------- */
document.addEventListener('DOMContentLoaded', function() {
    var savedLoc = sessionStorage.getItem('gs_location');
    if (savedLoc) window.selectedPickupLocation = savedLoc;

    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;
    });
});

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
});
